export const MotorCycleInsuranceQuoteTestData = {
   /**
    * Step 0 data ...
    */
   discoveryType: 'Search Engine', // e.g., 'Search Engine', 'Social Media', 'Referral'
   referrersName: 'Google',
   contactOptions: ['Email', 'Phone'], // Array of contact preferences
   discountCode: 'SUMMER25', // Test with a valid-looking code
   
   /**
    * Step 1 : Data .... (Applicant/Rider Details)
    */
   title: 'Mr',
   firstName: 'Elias',
   lastName: 'Vance',
   birthDate: '1995-03-22', // Must be an adult (e.g., over 25 for better rates)
   email: 'elias.vance@testmail.com',
   phone: '07700900123',
   gender: 'Male',
   
   houseNumber: '14A',
   addressLine1: 'Black Mesa Drive',
   addressLine2: 'Industrial Estate',
   postCode: 'SE1 7PB', // A typical UK postcode
   maritalStatus: 'Single',
   employmentStatus: 'Employed', // e.g., 'Employed', 'Self-Employed', 'Retired', 'Student'
   
   isHomeOwner: 'Yes',
   hasChildrenUnder16: 'No',
   
   canBeContactedForThisQuote: 'Yes',
   contactEmail: 'elias.vance@testmail.com',
   contactPhone: '07700900123',
   canBeContactedForProductsAndServices: 'No',
   
   mainOccupation: 'Software Developer',
   occupationIndustry: 'IT and Telecommunications',
   hasAdditionalJobs: 'No',
   
   /**
    * Step 2 Data ... (Policy and Riding History)
    */
   "policyStartDate": "2025-12-01", // Future date (e.g., 3 weeks from now)
   "currentPolicyExpireDate": "2025-11-30", // Day before new policy starts
   "previousInsurerName": "BikerShield Insurance",
   "bikeRider": 'Insured Only', // e.g., 'Main Rider Only', 'Main Rider and Partner'
   "bikeUsage": 'Social Domestic & Pleasure', // e.g., 'Social, Domestic, & Pleasure', 'Commuting', 'Business'
   "bikeLicenseType": 'EEC',
   "bikeLicenseDate": '2015-05-15', // Must be several years ago
   "hasARidingQualification": 'Yes', // e.g., 'Advanced Rider Training'
   "isMemberOfBikeOrganisation": 'Yes',
   "bikeNoClaimBonusYears": '5 years', // High NCB for a good rate
   "noOfOtherOwnedVehicles": '1',
   "noOfOtherOwnedAndInsuredVehicles": '1',
   "hasMedicalConditionsAffectingRiding": 'No',
   "hasVehicleRelatedClaimsOrIncidents": 'No', // For a "clean record" test case
   "hasCriminalConvictions": 'No',
   
   /**
    * Step 3: Bike info ...
    */
   bikeRegNumber: 'AB10 XYZ', // Realistic UK style number plate
   bikeManufacturer: 'Yamaha',
   bikeModel: 'MT-07',
   bikeYear: '2022', // Modern bike
   
   isFittedWithSideCar: 'No',
   isImported: 'No',
   hasModifications: 'Yes', // Test case for modifications
   hasSecurityDeviceFitted: 'Yes',
   
   bikePurchaseDate: '2023-01-20',
   bikeRegistrationDate: '2022-03-15',
   
   registeredOwner: 'Proposer/Policyholder', // e.g., 'Proposer', 'Company', 'Finance'
   registeredKeeper: 'Employer', // e.g., 'Proposer', 'Other'
   bikeParkingAtHomeAddress: 'Car Park', // High security parking
   isBikeKeptOvernight: 'Yes',
   
   currentMileage: '8500',
   annualMileage: '4000',
   annualBusinessMileage: '0',
   
   willCarryPillionPassengers: 'Yes',
   willBeUsedForToeing: 'No',
   
   bikeMarketValue: '6500', // Realistic market value for a 2022 Yamaha MT-07
   
   /**
    * Step 4 ... (Cover Details)
    */
   levelOfCover: 'Comprehensive', // e.g., 'Comprehensive', 'Third Party, Fire & Theft', 'Third Party'
   voluntaryExcessAmount: '250', // Mid-range excess
   
   
   nameOfLastInsurer: 'BikerShield Insurance',
   renewalQuoteFromLastInsurer: '450.00', // A specific amount
   
   addAdditionalComments: 'Bike has aftermarket exhaust and tail tidy. Full service history available.',
   
   termsAgreement: 'Yes',
   
   // Test data for claims/convictions lists
   hasAccidentClaimsInLast5Years : 'Yes',
   motorAccidentsList: [
      {
         type : 'Accident',
         date : '2020-11-12',
         partyAtFault : 'Both parties',
      }
   ], // Clean record case
   
   hasMotoringConvictionsInLast5Years : 'Yes',
   
   motorConvictionsList: [{
      date : '2020-05-10',
      code : 'SP30',
      points : 3,
      fines : 100,
      banLengthInMonths : 3,
      wasDriverBreathalysed : 'Yes',
      wasOffenceAccidentRelated : 'No',
   }], // Clean record case
};